<div class="dialog-container list-popup">
  <!-- Header -->
  <div class="dialog-header">
    <div class="dialog-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="8" y1="6" x2="21" y2="6"></line>
        <line x1="8" y1="12" x2="21" y2="12"></line>
        <line x1="8" y1="18" x2="21" y2="18"></line>
        <line x1="3" y1="6" x2="3.01" y2="6"></line>
        <line x1="3" y1="12" x2="3.01" y2="12"></line>
        <line x1="3" y1="18" x2="3.01" y2="18"></line>
      </svg>
    </div>
    <h2 class="dialog-title">Liste des {{ data?.dataNameDisplayed || data?.dataName || 'éléments' }}</h2>
    <button type="button" class="btn-icon" mat-dialog-close>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>

  <!-- Search Bar (Fixed) -->
  <div class="search-section-fixed">
    <div class="search-box">
      <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="11" cy="11" r="8"></circle>
        <path d="m21 21-4.35-4.35"></path>
      </svg>
      <input
        type="text"
        class="search-input"
        [placeholder]="'Rechercher par ' + (data?.dataRechCol || 'mot-clé')"
        [(ngModel)]="termeRecherche"
        (ngModelChange)="surRecherche()">
    </div>
  </div>

  <!-- Content Area (Scrollable) -->
  <mat-dialog-content class="dialog-content">
    <!-- Affichage des Livreurs en cartes -->
    <div class="livreurs-grid" *ngIf="data.dataName === 'LivreursDisponibles' && donneesFiltrees.length > 0">
      <div class="livreur-card" *ngFor="let livreur of donneesFiltrees"
           [@slideIn] (mouseenter)="hoveredLivreur = livreur.id"
           (mouseleave)="hoveredLivreur = null"
           [class.hovered]="hoveredLivreur === livreur.id">

        <!-- Avatar et infos principales -->
        <div class="card-header">
          <div class="livreur-avatar">
            <span class="avatar-icon">👤</span>
          </div>
          <div class="livreur-info-main">
            <h3 class="livreur-name">{{ livreur.nom }} {{ livreur.prenom }}</h3>
            <span class="livreur-status">Disponible</span>
          </div>
        </div>

        <!-- Détails -->
        <div class="card-body">
          <div class="detail-row">
            <span class="detail-icon">📱</span>
            <span class="detail-value">{{ livreur.contact || '—' }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-icon">📍</span>
            <span class="detail-value">{{ livreur.adresse || 'Non spécifiée' }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-icon">📦</span>
            <span class="detail-value">{{ livreur.nombreCommandesEnCours || 0 }} en cours</span>
          </div>
        </div>

        <!-- Action -->
        <div class="card-footer">
          <button class="btn btn-select-card" (click)="selectionner(livreur)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            Sélectionner
          </button>
        </div>
      </div>
    </div>

    <!-- Affichage par défaut (table) pour les autres types -->
    <div class="table-wrapper" *ngIf="data.dataName !== 'LivreursDisponibles' && donneesFiltrees.length > 0">
      <table class="data-table">
        <thead>
          <tr>
            <th *ngFor="let column of data.displayedColumns" [style]="column.width ? 'width:' + column.width : ''">
              {{ column.name }}
            </th>
            <th style="width: 120px;">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let dataLine of donneesFiltrees">
            <td *ngFor="let column of data.displayedColumns" [style]="column.style || ''">
              {{ obtenirDonneesColonne(dataLine, column.field) }}
            </td>
            <td>
              <button class="btn btn-select" (click)="selectionner(dataLine)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                Sélectionner
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Empty State -->
    <div *ngIf="donneesFiltrees.length === 0" class="empty-state">
      <div class="empty-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
          <path d="M8 8l6 6M14 8l-6 6" stroke-width="1.5"></path>
        </svg>
      </div>
      <p>Aucun résultat trouvé</p>
      <span class="empty-hint" *ngIf="termeRecherche">Essayez avec d'autres termes de recherche</span>
    </div>

    <!-- Loading -->
    <div *ngIf="estEnChargement" class="loading-container">
      <div class="spinner"></div>
      <p>Chargement des données...</p>
    </div>
  </mat-dialog-content>

  <!-- Footer -->
  <div class="dialog-actions">
    <span class="results-count" *ngIf="!estEnChargement">
      {{ donneesFiltrees.length }} résultat(s)
    </span>
    <button type="button" class="btn btn-secondary" mat-dialog-close>Fermer</button>
  </div>
</div>
